import { datadogLogs } from '@datadog/browser-logs';
import { useQuery } from '@tanstack/react-query';
import { QUERY_MEETING_TOKEN_KEY } from '@web-app/hooks/consts';
import axios from 'axios';

const MEETING_TOKEN_TIMEOUT_MS = 15000;

const getMeetingToken = async (roomId: string): Promise<{ token: string }> => {
  try {
    const response = await axios.post(
      '/api/user/meeting-token',
      {
        roomId,
      },
      {
        timeout: MEETING_TOKEN_TIMEOUT_MS,
      },
    );

    return response.data;
  } catch (err) {
    if (axios.isAxiosError(err) && err.code === 'ECONNABORTED') {
      datadogLogs.logger.error('[Meeting Token] Request timed out', {
        roomId,
        timeout: MEETING_TOKEN_TIMEOUT_MS,
        error: err.message,
        errorCode: err.code,
      });
      const timeoutError = new Error(
        'Meeting token request timed out. Please check your internet connection and try again.',
      );
      timeoutError.name = 'TimeoutError';
      throw timeoutError;
    }
    datadogLogs.logger.error('[Meeting Token] Error getting token', {
      roomId,
      error: err instanceof Error ? err.message : String(err),
      errorStack: err instanceof Error ? err.stack : undefined,
    });
    throw err;
  }
};

export const useMeetingToken = (roomId: string, enabled: boolean) => {
  return useQuery({
    queryKey: [QUERY_MEETING_TOKEN_KEY, roomId],
    queryFn: () => getMeetingToken(roomId),
    enabled,
  });
};
